import { axiosRequest } from "../../service";
import {
  REACT_APP_IU_NAMES,
  REACT_APP_KSHEMA_POC1,
  REACT_APP_KSHEMA_POC2,
  REACT_APP_SAW_CCE_SEARCH,
} from "../../urls";

export const fetchCCEData = async (payload) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_KSHEMA_POC1}/${REACT_APP_SAW_CCE_SEARCH}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CCE data:", error);
    throw error;
  }
};

export const fetchIUNames = async ({
  state,
  year,
  season,
  district,
  mandal,
}) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_KSHEMA_POC1}/${REACT_APP_IU_NAMES}?stateName=${state}&year=${year}&season=${season}&districtName=${district}&mandalName=${mandal}`
    );
    return response?.data?.data?.map((iu) => {
      return {
        label: iu?.insuranceUnitName,
        value: iu?.insuranceUnitCode,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching IU data:", error);
    throw error;
  }
};

export const fetchCropList = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_KSHEMA_POC2}/crop-master/pmfby`
    );
    const crops = response.data.crops;
    const mappedCrops = crops.map(crop => ({
      label: crop.cropName,
      value: crop.cropName
    }));
    return mappedCrops;
  } catch (error) {
    console.error('Error fetching states:', error);
    return [];
  }
};

export const groupByLocationAndCrop = (data) => {
  const grouped = {};

  data.forEach((entry) => {
    let location, label, codeKey, codeValue;

    if (entry.insuranceUnitName) {
      location = entry.insuranceUnitName;
      label = "iu";
      codeKey = "iuCode";
      codeValue = entry.insuranceUnitCode;
    } else if (entry.mandalName) {
      location = entry.mandalName;
      label = "mandal";
    } else if(entry.districtName){
      location = entry.districtName;
      label = "district";
    } else {
      location = entry.stateName;
      label = "state";
    }

    if (!grouped[location]) {
      grouped[location] = {
        label,
        codeKey,
        codeValue,
        crops: [],
      };
    }

    grouped[location].crops.push({
      ...entry
    });
  });

  return Object.entries(grouped).map(([location, data]) => {
    const result = {
      [data.label]: location,
      count: data.crops,
    };
    if (data.codeKey && data.codeValue) {
      result[data.codeKey] = data.codeValue;
    }
    return result;
  });
};

